/** Shared dark-mode readable text tokens for Performance Dashboard V2 */

export const v2LabelSx = (theme) => ({
  color: theme.palette.mode === "dark" ? "#D0D0D0" : theme.palette.text.secondary,
});

export const v2MutedSx = (theme) => ({
  color: theme.palette.mode === "dark" ? "#B8B8B8" : theme.palette.text.secondary,
});

export const v2CardBg = (theme) =>
  theme.palette.mode === "dark" ? "#1a1818" : theme.palette.background.paper;

export const v2CardBorder = (theme) =>
  theme.palette.mode === "dark" ? "rgba(255,255,255,0.14)" : theme.palette.divider;

export const v2PeriodTint = (theme, positive) => {
  const base = positive ? theme.palette.success.main : theme.palette.error.main;
  return theme.palette.mode === "dark"
    ? `${base}33` // ~20% opacity
    : `${base}1F`; // ~12%
};

/** Neutral accent — avoids blue primary in dark mode */
export const v2Accent = (theme) =>
  theme.palette.mode === "dark" ? "#E8E8E8" : theme.palette.primary.main;

export const v2AccentSoftBg = (theme) =>
  theme.palette.mode === "dark" ? "rgba(255,255,255,0.1)" : `${theme.palette.primary.main}14`;

export const v2SelectedChipSx = (theme) =>
  theme.palette.mode === "dark"
    ? {
        fontWeight: 600,
        flexShrink: 0,
        borderRadius: 1.5,
        color: "#111111",
        backgroundColor: "#E8E8E8",
        border: "1px solid #E8E8E8",
        "&:hover": {
          backgroundColor: "#FFFFFF",
          borderColor: "#FFFFFF",
        },
        "& .MuiChip-label": { color: "inherit" },
      }
    : {
        fontWeight: 600,
        flexShrink: 0,
        borderRadius: 1.5,
      };

/** Autocomplete / Select field sizing aligned with V2 control bars */
export const v2ControlFieldSx = ({ sm = 240, min = 200 } = {}) => ({
  width: { xs: "100%", sm },
  minWidth: min,
  "& .MuiInputBase-input": { fontSize: "0.95rem" },
  "& .MuiInputLabel-root": {
    fontSize: "0.9rem",
    color: "text.secondary",
  },
});

export const v2SelectLabelSx = {
  color: "text.secondary",
  fontSize: "0.9rem",
};

export const v2AutocompleteSlotProps = (theme) => ({
  popper: {
    sx: {
      zoom: 0.75,
      zIndex: (t) => t.zIndex.modal + 1,
    },
  },
  paper: {
    sx: {
      borderRadius: 1.5,
      border: `1px solid ${v2CardBorder(theme)}`,
      backgroundColor: v2CardBg(theme),
      backgroundImage: "none",
    },
  },
  listbox: {
    sx: {
      "& .MuiAutocomplete-option": {
        fontSize: "0.95rem",
        py: 0.75,
      },
    },
  },
});

export const filterStringOptions = (options, { inputValue }) => {
  const q = inputValue.trim().toLowerCase();
  if (!q) return options;
  return options.filter((option) =>
    String(option ?? "")
      .toLowerCase()
      .includes(q)
  );
};

export const filterFundOptions = (options, { inputValue }) => {
  const q = inputValue.trim().toLowerCase();
  if (!q) return options;
  return options.filter(
    (f) =>
      f.abbreviation?.toLowerCase().includes(q) ||
      f.name?.toLowerCase().includes(q)
  );
};
